import { useGlobalState } from '@highlight/ipc/react'
import { clearCurrentDetection, DetectedType } from '@shared/store/impl/detection.ts'
import { useCallback, useMemo } from 'react'

export const useScreenshotActivity = () => {
  const [detection] = useGlobalState<DetectedType>('currentDetection')

  const detectedScreenshot = useMemo(() => {
    if (detection?.type !== 'image') {
      return undefined
    }
    return detection.value
  }, [detection])

  const clearDetectedScreenshot = useCallback(() => {
    clearCurrentDetection('image')
  }, [])

  return useMemo(() => {
    return {
      detectedScreenshot,
      clearDetectedScreenshot,
    }
  }, [detectedScreenshot, clearDetectedScreenshot])
}
